"use strict";

exports.__esModule = true;
exports.historicalPartCountShift = void 0;
var _vimanaTypes = require("@vimana/vimana-types");
var historicalPartCountShift = exports.historicalPartCountShift = function historicalPartCountShift(translate) {
  return {
    columns: [{
      id: "deviceName",
      sortId: "device.value",
      name: translate("DataTable.Column.Title.deviceName", "Device"),
      type: "deviceName",
      enableSorting: true,
      canSearch: true
    }, {
      id: "shift",
      name: translate("DataTable.Column.Title.shift", "Shift"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "partKind",
      name: translate("DataTable.Column.Title.partKind", "Part Kind"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "partProcess",
      name: translate("DataTable.Column.Title.partProcess", "Part Process"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "workDay",
      name: translate("DataTable.Column.Title.workDay", "Workday"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "goodPartCount",
      name: translate("DataTable.Column.Title.goodPartCount", "Good Part Count"),
      type: "string",
      enableSorting: true,
      sortMethod: function sortMethod(a, b) {
        return Number(b) - Number(a);
      }
    }, {
      id: "badPartCount",
      name: translate("DataTable.Column.Title.badPartCount", "Bad Part Count"),
      type: "string",
      enableSorting: true,
      sortMethod: function sortMethod(a, b) {
        return Number(b) - Number(a);
      }
    }],
    parseData: function parseData(responseData) {
      return {
        index: responseData.index,
        deviceName: responseData.device,
        shift: responseData.shift,
        partKind: responseData.partKind,
        partProcess: responseData.partProcess,
        workday: responseData.workday,
        elementCount: responseData.elementCount,
        goodPartCount: responseData.goodPartCount,
        badPartCount: responseData.badPartCount,
        actions: responseData
      };
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto",
        columns: [{
          id: "deviceName",
          sortId: "device.value",
          name: translate("DataTable.Column.Title.deviceName", "Device"),
          type: "deviceName",
          enableSorting: true,
          canSearch: true
        }, {
          id: "shift",
          name: translate("DataTable.Column.Title.shift", "Shift"),
          type: "string",
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "partKind",
          name: translate("DataTable.Column.Title.partKind", "Part Kind"),
          type: "string",
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "partProcess",
          name: translate("DataTable.Column.Title.partProcess", "Part Process"),
          type: "string",
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "workDay",
          name: translate("DataTable.Column.Title.workDay", "Workday"),
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "goodPartCount",
          name: translate("DataTable.Column.Title.goodPartCount", "Good Part Count"),
          type: "string",
          enableSorting: true,
          sortMethod: function sortMethod(a, b) {
            return Number(b) - Number(a);
          }
        }, {
          id: "badPartCount",
          name: translate("DataTable.Column.Title.badPartCount", "Bad Part Count"),
          type: "string",
          enableSorting: true,
          sortMethod: function sortMethod(a, b) {
            return Number(b) - Number(a);
          }
        }]
      };
    }
  };
};